export const RELATIONSHIP_LEFT_JOIN = "LeftOuterJoin";
export const RELATIONSHIP_INNER_JOIN = "InnerJoin";

export const DEFAULT_RELATIONSHIP = {
    joinType: RELATIONSHIP_INNER_JOIN,
};
